import React, { useState } from "react";
import { reset_password_api } from "../../DAL/Users";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react";
import SubmitButton from "../GeneralComponents/SubmitButton";

export default function ResetPassword(props) {
  const { formData, setFormData, setErrors, errors, handleLogin } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState({
    new_password: "password",
    confirm_password: "password",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { ...formData };
    const result = await reset_password_api(postData);
    if (result.code === 200) {
      handleLogin();
    } else {
      toast.error(`${result.message}`);
      setIsLoading(false);
    }
  };

  const handleChangeIcon = (name) => {
    const updateName = `${name}_password`;
    let password_type = "password";
    if (passwordType[updateName] === "password") {
      password_type = "text";
    }
    setPasswordType((old) => ({ ...old, [updateName]: password_type }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group mt-2">
        <label htmlFor="password">New Password</label>
        <div className="input-wrapper">
          <Icon
            icon={`mdi:eye${
              passwordType.new_password === "password" ? "-off" : ""
            }`}
            className="eye-icon"
            onClick={() => handleChangeIcon(`new`)}
          />
          <input
            type={passwordType.new_password}
            id="password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
            placeholder="Enter new password"
            className={`ps-3 ${errors.email ? "has-error" : ""}`}
          />
        </div>
        {errors.password && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.password}
          </span>
        )}
      </div>
      <div className="form-group mt-2">
        <label htmlFor="password">Confirm Password</label>
        <div className="input-wrapper">
          <Icon
            icon={`mdi:eye${
              passwordType.confirm_password === "password" ? "-off" : ""
            }`}
            className="eye-icon"
            onClick={() => handleChangeIcon(`confirm`)}
          />
          <input
            type={passwordType.confirm_password}
            id="password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            placeholder="Enter confirm password"
            className={`ps-3 ${errors.email ? "has-error" : ""}`}
          />
        </div>
        {errors.password && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.password}
          </span>
        )}
      </div>
      <div className="forget-password mt-2">
        <span className="login-forget-password" onClick={handleLogin}>
          Back to login?
        </span>
      </div>
      <SubmitButton
        isLoading={isLoading}
        btnText="Reset Password"
        loadingText="Submitting..."
      />
    </form>
  );
}
